<script setup lang="ts">
  import { syncCheckedAfterClick } from '@/helpers/formControl'

  const props = defineProps<{
    modelValue?: boolean
    label?: string
    disabled?: boolean
  }>()
</script>

<template>
  <label
    class="relative isolate inline-flex gap-2 items-center select-none"
    :class="{ 'cursor-not-allowed': disabled }"
  >
    <input
      class="peer absolute inset-0 z-1 size-full m-0 appearance-none opacity-0"
      :class="disabled ? 'pointer-events-none' : 'cursor-pointer'"
      type="checkbox"
      :checked="modelValue"
      :disabled="disabled"
      @input="!disabled && $emit('update:modelValue', !modelValue)"
      @click="syncCheckedAfterClick($event, () => !!props.modelValue)"
    />
    <div
      class="w-4 h-4 pb-1 relative border inline-flex shrink-0 transition-colors rounded-sm items-center justify-center pointer-events-none peer-focus-visible:outline-2 peer-focus-visible:outline-offset-2 peer-focus-visible:outline-blue-50"
      :class="{
        'bg-blue-50 border-blue-50': modelValue && !disabled,
        'bg-blue-90 border-blue-90': modelValue && disabled,
        'bg-white border-black-40': !modelValue && !disabled,
        'bg-white border-black-90': !modelValue && disabled,
      }"
    >
      <div class="w-2.5 h-1.5 -rotate-45 border-white border-b-2 border-l-2"></div>
    </div>
    <span v-if="label" class="text-sm">{{ label }}</span>
  </label>
</template>
